import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAttendanceByDate } from './firebase';
import {
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY
} from './constants';

export const fetchAttendance = createAsyncThunk('fetchAttendance', async (startDate) => await getAttendanceByDate(startDate));

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState: {},
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchAttendance.pending, (state, action) => {
        state[action.meta.arg] = {}
        state[action.meta.arg].status = STATUS_FETCHING
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state[action.meta.arg].status = STATUS_READY
        state[action.meta.arg].data = action.payload
      })
      .addCase(fetchAttendance.rejected, (state, action) => {
        state[action.meta.arg].status = STATUS_ERROR
        state[action.meta.arg].error = action.error.message
      })
  }
})

export default attendanceSlice.reducer
